import { createApi, encrypt } from "@luzhongk/vue-request";
import { toast } from "@luzhongk/vue-request";
import authority from "@/utils/authority";

const isDev = process.env.NODE_ENV === "development";

const testToken = isDev
  ? "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zZXJ2aWNlLndlZGRpbmdlZS5jb206ODAwNVwvYXBpXC9hcHAtaW52aXRhdGlvblwvdjFcL2xvZ2luIiwiaWF0IjoxNTc0NTg0NDgyLCJleHAiOjE1ODMyMjQ0ODIsIm5iZiI6MTU3NDU4NDQ4MiwianRpIjoiWUtob05QYm1XbGE5ZWhXcCIsInN1YiI6MSwicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSIsImlkIjoiMSIsImZyb20iOiJsaWNoZW5nLWFwcCJ9.XSPX0ZK25zPlRVeqmDVIFR5hjeIJWd7yUm0TtKTicdo"
  : "";

// 加密key
const key = "95bd85d5a287556a386444b82559ee45";

const request = createApi({
  setHeaders: config => {
    const { params = {}, data = {} } = config;
    const now = Date.parse(new Date()) / 1000;
    const headers = {
      "X-Halo-App": "invitation-web",
      "X-Http-Request-Halo-Time": now,
      "X-Http-Request-Halo-Sign": encrypt(
        { ...params, ...data, time: now },
        key
      )
    };
    const { token = testToken } = authority.get() || {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  },
  loginForce() {
    toast("登陆失效");
  }
});

export default request;
